import axios from "axios";
import AccountAppointment from "../models/AccountAppointment";
import AppointmentApplicationRequest from "../models/AppointmentApplicationRequest";
import { AccountEndPoints } from "../Settings/EndPoints";

class AccountService {
  async requestAppointment(
    request: AppointmentApplicationRequest
  ): Promise<AccountAppointment[]> {
    const resp = await axios.post(AccountEndPoints.RequestAppointment, request);
    return resp.data;
  }

  async getAppointments(): Promise<AccountAppointment[]> {
    const resp = await axios.get(AccountEndPoints.GetAppointments);
    return resp.data;
  }

  async deleteAppointment(
    appointmentId: number
  ): Promise<AccountAppointment[]> {
    const resp = await axios.delete(
      `${AccountEndPoints.DeleteAppointment}/${appointmentId}`
    );
    return resp.data;
  }
}
const accountService = new AccountService();

export default accountService;
